import React from "react";
import NotAccess from "../../components/common/userNotAccess/index";
import { IsShowShipment } from "../../utils";

function RestrictShipment(props) {
  if (IsShowShipment()) return props.children;
  return <NotAccess />;
}

export default RestrictShipment;
